import { derived, writable } from "svelte/store";
import { fetchStatus, sendState } from "./instachat";
const internalError = writable(null);
export const error = derived(internalError, $internalError => $internalError);
const internalState = writable('UNKNOWN', set => {
    const fetchTheStatus = () => fetchStatus().then(status => set(status)).catch(e => internalError.set(e));
    fetchTheStatus();
    const timer = setInterval(() => {
        fetchTheStatus();
    }, 10000);
    return () => {
        clearInterval(timer);
    };
});
export const state = derived(internalState, $internalState => $internalState);
export const setState = async (state) => {
    try {
        const current = await sendState(state);
        internalState.set(current);
    }
    catch (e) {
        internalError.set(e.toString());
    }
};
export const setSupervisorPresent = async () => {
    try {
        const current = await sendState('SUPERVISOR_PRESENT');
        internalState.set(current);
    }
    catch (e) {
        internalError.set(e.toString());
        throw e;
    }
};
export const clearError = () => internalError.set(null);
